import * as React from "react";
const SvgFiRrArrowsToEye = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-arrows-to-eye_svg__a)">
      <path
        fill="#062147"
        d="M18.802 12.82a1.78 1.78 0 0 0 0-1.64q0 0-.002-.003C18.346 10.295 15.861 7 12 7s-6.346 3.296-6.798 4.175a1.79 1.79 0 0 0-.002 1.647C5.654 13.704 8.138 17 12 17s6.346-3.296 6.802-4.18M12 15c-2.688 0-4.558-2.322-4.969-3 .406-.67 2.277-3 4.97-3 2.691 0 4.561 2.327 4.968 3-.407.673-2.28 3-4.969 3m2-3a2 2 0 1 1-3.999.001 2 2 0 0 1 4 0M.293 1.707A.999.999 0 1 1 1.707.293L5 3.586V2a1 1 0 1 1 2 0v2.49a2.504 2.504 0 0 1-2.49 2.5L2.004 7H2a1 1 0 0 1-.004-2l1.584-.006zM17.01 4.51 17 2.004A1 1 0 0 1 17.996 1H18a1 1 0 0 1 1 .996l.006 1.584L22.293.293a.999.999 0 1 1 1.414 1.414L20.414 5H22a1 1 0 1 1 0 2h-2.49a2.504 2.504 0 0 1-2.5-2.49M7 19.51V22a1 1 0 1 1-2 0v-1.586l-3.293 3.293a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l3.287-3.287L1.996 19A1 1 0 0 1 2 17h.004l2.506.01A2.504 2.504 0 0 1 7 19.51m16.707 2.783a.999.999 0 1 1-1.414 1.414l-3.287-3.287L19 22.004A1 1 0 0 1 18 23h-.004A1 1 0 0 1 17 21.996l.01-2.506a2.504 2.504 0 0 1 2.5-2.49H22a1 1 0 1 1 0 2h-1.586z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-arrows-to-eye_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrArrowsToEye;
